export default [
  { value: 'MO', text: 'Monday' },
  { value: 'TU', text: 'Tuesday' },
  { value: 'WE', text: 'Wednesday' },
  { value: 'TH', text: 'Thursday' },
  { value: 'FR', text: 'Friday' },
  { value: 'SA', text: 'Saturday' },
  { value: 'SU', text: 'Sunday' }
]
